import { RootState } from '@AppState/redux-store'
import { MaskedValue } from '@Components/common/masked-value'
import { AdminTicketScanResponse, AuthScopes } from '@Generated/back-office-client/src'
import { Box } from '@radix-ui/themes'
import { PlayerServiceAPI } from '@API/data-services/player-service.ts'
import { useSelector } from 'react-redux'

type TicketBarcodeProps = {
  ticketScan: AdminTicketScanResponse
  // Injectable so stories/tests can stub the decrypt fetch without module mocking.
  fetchFullBarcode?: (scanId: string) => Promise<string>
}

const defaultFetchFullBarcode = (scanId: string) =>
  PlayerServiceAPI.getFullTicketScan(scanId).then((scan) => scan.decryptedBarcode)

export const TicketBarcode = ({
  ticketScan,
  fetchFullBarcode = defaultFetchFullBarcode,
}: TicketBarcodeProps) => {
  const { currentUser } = useSelector((state: RootState) => state.users)
  const canReveal = currentUser?.scopes.includes(AuthScopes.readbarcodes) ?? false

  return (
    <Box className="scan-barcode-cell">
      <MaskedValue
        label="barcode"
        canReveal={canReveal}
        maskedDisplay={`*****${ticketScan.truncatedBarcode ?? ''}`}
        onReveal={() => fetchFullBarcode(ticketScan.scanId)}
      />
    </Box>
  )
}
